















import Vue from 'vue'

export default Vue.extend({
  name: 'SolidPrimaryButton',
  props: {
    text: { type: Boolean, default: false },
    color: { type: String, default: 'primary' },
  },
})
